import React from 'react';
import { FOOTER } from '../constants/content';
export function SiteFooter() {
  return <footer className="w-full bg-night py-10 text-cream/70" data-id="element-236" data-mp="3r8j1sroegsk0">
      <div className="mx-auto max-w-4xl px-4 text-center b720:px-6" data-id="element-237" data-mp="3racd4k9yk0yc">
        <p className="font-display text-lg font-700 uppercase tracking-wide text-mustard" data-id="element-238" data-mp="3mg85dysvbow7">
          {FOOTER.brand}
        </p>

        <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs b640:text-sm" data-id="element-239" data-mp="3hgdg1zoqr7d9">
          {FOOTER.links.map(link => <li key={link} data-id="element-240" data-mp="38h8fkntmd3yg">
              <a href="#" className="underline-offset-4 transition-colors hover:text-mustard hover:underline" data-id="element-241" data-mp="38gyr54o834uv">
                {link}
              </a>
            </li>)}
        </ul>

        <p className="mx-auto mt-6 max-w-2xl text-[11px] leading-relaxed text-cream/50 b640:text-xs" data-id="element-242" data-mp="2ylyfw6qp18nu">
          {FOOTER.legal}
        </p>
      </div>
    </footer>;
}